<template>
  <section id="heroSection">
    <div>
      <div class="modal-bg" v-show="bgActive"></div>
      <div class="select-subTitle">
        <div>영상회의</div>
        <div style="display: flex;">
          <div style="font-size: 15px; font-weight: 500; margin-right: 10px;">{{ $store.state.user.name }}님</div>
          <div
            v-if="['a'].includes($store.state.user.authorize)"
            @click="logout"
            style="
              font-size: 13px;
              background-color: blueviolet;
              color: white;
              border-radius: 5px;
              width: 80px;
              height: 30px;
              text-align: center;
              cursor: pointer;
            "
          >
            임시 로그아웃
          </div>
        </div>
      </div>
      <div class="header-container">
        <div style="font-weight: bold;">* 예약/ 수정/ 삭제는 주 예약 시스템(협업, 임원보고, 포털)에서 가능합니다.</div>
        <button
          v-if="['a'].includes($store.state.user.authorize)"
          class="reg-videoBtn"
          @click="goMeeting('video')"
          style="width: 130px; height: 30px; font-size: 13px"
        >
          등록
        </button>

        <div class="search-wrap" style="align-items: center">
          <date-picker
            v-model="startDate"
            format="YYYY.MM.DD"
            value-type="format"
            :lang="lang"
            style="width: 110px; height: 30px; font-size: 13px"
          ></date-picker>

          <span
            class="hyphen"
            style="margin: 0 5px; padding-top: 0; color: #333"
            >~</span
          >
          <date-picker
            v-model="endDate"
            format="YYYY.MM.DD"
            value-type="format"
            :lang="lang"
            style="width: 110px; height: 30px; font-size: 13px"
            :disabled-date="notBeforeStartDate"
          ></date-picker>
          <input
            class="search-inputbox"
            style="
              width: 300px;
              margin-left: 6px;
              padding-left: 10px;
              height: 30px;
            "
            type="text"
            v-model="searchText"
            placeholder="회의 제목 또는 개설자를 검색해주세요"
            @keyup.enter="search('sc')"
          />
          <select
            style="width: 100px; height: 30px; margin-left: 6px"
            v-model="meetingStatus"
          >
            <option value="all">전체</option>
            <option value="r">예정</option>
            <option value="s">진행중</option>
            <option value="e">완료</option>
          </select>
          <button
            class="krx-search-btn"
            style="margin-left: 6px"
            @click="search('sc')"
          ></button>
        </div>
      </div>
      <div class="contents-container">
        <table
          class="mymeet_info"
          cellpadding="0"
          cellspacing="0"
          style="min-width: 1350px; border-collapse: collapse"
        >
          <caption>
            이 표는 구성되어 있습니다.
          </caption>
          <colgroup>
            <col style="width: 7%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 8%" />
            <col style="width: 33%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <!-- <col style="width:10%;" /> -->
          </colgroup>
          <tbody>
            <tr class="top">
              <td style="border-radius: 8px 0 0 8px">구분</td>
              <td class="sort-wrap"> <!-- @click="sortDate()" -->
                회의 날짜
                <div class="upDown-img-wrap">
                  <img :src="dateTopImage" class="up-img" />
                  <img :src="dateDownImage" class="down-img" />
                </div>
              </td>
              <td class="sort-wrap">
                회의 예약 시간
              </td>
              <td class="sort-wrap"> <!-- @click="@click="sortProcess()" -->
                상태

                <div class="upDown-img-wrap">
                  <img :src="processTopImage" class="up-img" />
                  <img :src="processDownImage" class="down-img" />
                </div>
              </td>
              <td class="sort-wrap"> <!-- @click="sortTitle()" -->
                회의 제목

                <div class="upDown-img-wrap">
                  <img :src="titleTopImage" class="up-img" />
                  <img :src="titleDownImage" class="down-img" />
                </div>
              </td>

              <td class="sort-wrap"> <!-- @click="sortCreator()" -->
                개설자

                <div class="upDown-img-wrap">
                  <img :src="creatorTopImage" class="up-img" />
                  <img :src="creatorDownImage" class="down-img" />
                </div>
              </td>

              <td class="sort-wrap"> <!-- @click="sortDept()" -->
                부서

                <div class="upDown-img-wrap">
                  <img :src="deptTopImage" class="up-img" />
                  <img :src="deptDownImage" class="down-img" />
                </div>
              </td>

              <td class="text-center">회의 참여</td>
              <td class="text-center">녹화 다운로드</td>
              <td class="text-center" style="border-radius: 0 8px 8px 0">
                제어
              </td>

              <!-- <td>
              회의록
            </td> -->
            </tr>
            <!-- 회의 리스트 -->
            <tr
              v-for="listItem in calData"
              class="meetings-row"
              :key="listItem.meetingKey"
              :class="{ isToday: listItem.isToday }"
            >
              <td v-if="listItem.type === 'video'">
                <img
                  style="position: relative; top: 2px"
                  src="../../src/images/button/krxVideo.png"
                />
                <span style="margin-left: 2px">{{
                  listItem.conferenceRoomActive === true ? '고화질' : '일반'
                }}</span>
              </td>
              <td>
                {{ getMeetingDateString(listItem) }}
              </td>
              <td>
                {{ listItem.startDtime | formatTime }} ~
                {{
                  (listItem.displayEndDtime || listItem.endDtime) | formatTime
                }}
              </td>
              <td>
                {{ statusKr(listItem.status) }}
              </td>

              <td
                style="cursor: pointer"
                v-if="
                  listItem.creator.email === $store.state.user.email &&
                  listItem.status === 'r'
                "
                @click="onInfo(listItem)"
              >
                <img
                  v-if="listItem.allPublicMeeting"
                  class="all-public-meeting"
                  src="../../src/images/button/allPublicMeeting.png"
                />{{ listItem.title }}
              </td>
              <td
                v-else-if="listItem.status === 'e' || listItem.status === 's'"
                @click="onInfo(listItem)"
                style="cursor: pointer"
              >
                <img
                  v-if="listItem.allPublicMeeting"
                  class="all-public-meeting"
                  src="../../src/images/button/allPublicMeeting.png"
                />{{ listItem.title }}
              </td>
              <td
                style="cursor: pointer"
                v-else-if="listItem.creator.email !== $store.state.user.email"
                @click="onInfo(listItem)"
              >
                <img
                  v-if="listItem.allPublicMeeting"
                  class="all-public-meeting"
                  src="../../src/images/button/allPublicMeeting.png"
                />{{ listItem.title }}
              </td>
              <td>
                {{
                  listItem.creator.username
                    ? listItem.creator.username
                    : listItem.creator.name
                }}
              </td>
              <td>
                {{
                  listItem.creator.department
                    ? listItem.creator.department
                    : listItem.creator.DEPT_NM
                }}
              </td>
              <td v-if="listItem.status === 'r'" class="text-center"></td>
              <td v-else-if="listItem.status === 's'" class="text-center">
                <button
                  class="join-meeting-btn"
                  @click="openConfirmDialog(listItem)"
                >
                  참여하기
                </button>
              </td>
              <td v-else class="text-center"></td>
              <td class="text-center">
                <button
                  v-if="
                    listItem.creator.email === $store.state.user.email && 
                    listItem.status === 'e' &&
                    listItem.recordList &&
                    listItem.recordList.length >= 1
                  "
                  class="join-meeting-btn"
                  @click="openRecInfodailog(listItem)"
                >
                  다운로드
                </button>
              </td>
              <td class="text-center">
                <img
                  v-if="
                    listItem.status === 's' &&
                    listItem.creator.email === $store.state.user.email
                  "
                  src="/static/icon-contents/set.svg"
                  @click="controlItem(listItem)"
                  style="width: 20px; cursor: pointer"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="paging">
        <div class="boardnavi">
          <pagination
            :records="meeting.length"
            v-model="page"
            :per-page="perPage"
          />
        </div>
      </div>

      <meeting-info-dialog
        :dialog="meetingInfoDialog.dialog"
        :defaultMeeting="meetingInfoDialog.meeting"
        :closeDialog="closeMeetingInfoDialog"
        @editedMeeting="editedMeeting"
      />
      <!-- RecInfoDialog -->
      <rec-info-dialog
        :dialog="recInfoDialog.dialog"
        :meetingInfo="recInfoDialog.meetingInfo"
        :closeDialog="closeRecInfoDialog"
      />
      <video-meeting-create-dialog
        :dialog="videoMeetingCreateDialog.dialog"
        :meetingInfo="meetingInfo"
        :mode="meetingInfo.meetingMode"
        :isTimeFixed="false"
        :isRoomSelectable="false"
        :closeDialog="closeMeetingCreateDialog"
        @createdMeeting="createdMeeting"
      />
      <edit-meeting-dialog
        :dialog="editMeetingDialog.dialog"
        :meetingInfo="editMeetingDialog.meeting"
        :isTimeFixed="false"
        @editedMeeting="editedMeeting"
      />

      <meeting-control-dialog
        :dialog="meetingControlDialog.dialog"
        :meeting="meetingControlDialog.meeting"
        :isManager="false"
        :closeDialog="closeMeetingControlDialog"
      />

      <meetingControlPCMobileOnlyDialog
        :dialog="meetingControlPCMobileOnlyDialog.dialog"
        :meeting="meetingControlPCMobileOnlyDialog.meeting"
        :isManager="false"
        :closeDialog="closeMeetingControlDialog"
      />

      <video-dialog
        :dialog="videoDialog.dialog"
        :meetingInfo="videoDialog.meetingInfo"
        :closeDialog="closeVideoDialog"
      />

      <confirm
        :dialog="confirmDialog.dialog"
        :contents="confirmDialog.contents"
        :agree="confirmAgree"
        :closeDialog="closeConfirm"
      />
      <check-password
        :dialog="checkPasswordDialog.dialog"
        :meetingInfo="checkPasswordDialog.meetingInfo"
        :closeDialog="closePassword"
        @joinPwMeeting="joinPwMeeting"
      />
    </div>
  </section>
</template>

<script>
import BaseModal from '@/components/popup/BaseModal';
import EditMeetingDialog from '@/components/popup/EditMeetingDialog';
import VideoMeetingCreateDialog from '@/components/popup/VideoMeetingCreateDialog';
import MeetingInfoDialog from '@/components/popup/MeetingInfoDialog';
import RecInfoDialog from '@/components/popup/RecInfoDialog';
import MeetingControlDialog from '@/components/popup/MeetingControlDialog';
import MeetingControlPCMobileOnlyDialog from '@/components/popup/MeetingControlPCMobileOnlyDialog';
import MeetingListEditDialog from '@/components/popup/MeetingListEditDialog';
import Confirm from '@/components/popup/Confirm';
import CheckPassword from '@/components/popup/CheckPassword';
import VideoDialog from '@/components/popup/VideoDialog';
import Pagination from 'vue-pagination-2';
import VueEnglishdatepicker from 'vue-englishdatepicker';
import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/index.css';

import debounce from 'lodash.debounce';
import Util from '@/util';
import moment from 'moment';

export default {
  components: {
    BaseModal: BaseModal,
    MeetingInfoDialog,
    EditMeetingDialog,
    MeetingControlDialog,
    MeetingControlPCMobileOnlyDialog,
    MeetingListEditDialog,
    RecInfoDialog,
    VideoMeetingCreateDialog,
    Pagination,
    DatePicker,
    VueEnglishdatepicker,
    VideoDialog,
    Confirm,
    CheckPassword,
  },
  filters: {
    koDateFormat: function (time) {
      moment.locale('ko');
      return moment(time).format('LL').replace(/(\s*)/g, '');
    },
    displayLongString: function (str) {
      if (str.length > 13) {
        return str.substring(0, 13) + '...';
      } else {
        return str;
      }
    },
    conferenceDayFilter: function (day) {
      return moment(day).format('YYYY.MM.DD');
    },
  },
  data: () => ({
    checkPasswordDialog: {
      dialog: false,
      meetingInfo: {},
    },
    showRegBtn: true,
    startMeetingItem: {},
    titleSort: 'desc',
    processSort: 'desc',
    dateSort: 'desc',
    deptSort: 'desc',
    dateTopImage: '/static/images/button/btn_align_top.png',
    dateDownImage: '/static/images/button/btn_align_down.png',
    processTopImage: '/static/images/button/btn_align_top.png',
    processDownImage: '/static/images/button/btn_align_down.png',
    titleTopImage: '/static/images/button/btn_align_top.png',
    titleDownImage: '/static/images/button/btn_align_down.png',
    creatorTopImage: '/static/images/button/btn_align_top.png',
    creatorDownImage: '/static/images/button/btn_align_down.png',
    deptTopImage: '/static/images/button/btn_align_top.png',
    deptDownImage: '/static/images/button/btn_align_down.png',
    creatorSort: 'desc',
    allPublicMeetingList: [],
    confirmDialog: {
      dialog: false,
      contents: '',
    },
    lang: {
      days: ['일', '월', '화', '수', '목', '금', '토'],
      months: [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ],
      yearFormat: 'YYYY년',
      monthFormat: 'MM월',
      // the calendar title of month before year
      monthBeforeYear: false,
    },
    pickrFormat: 'YYYY.MM.DD',
    page: 1,
    perPage: 12,
    dataPerPage: 12,
    bgActive: false,
    startDate: moment().add(-2, 'week').format('YYYY.MM.DD'),
    endDate: moment().add(2, 'week').format('YYYY.MM.DD'),
    searchText: '',
    meetingStatus: 'all',
    isActive: 'none',
    isEndActive: 'none',
    meeting: [],
    meetingInfo: {
      meetingType: null,
      meetingMode: null,
    },
    videoDialog: {
      dialog: false,
      meetingInfo: {},
    },
    editMeetingDialog: {
      dialog: false,
      meeting: {},
    },
    videoMeetingCreateDialog: {
      dialog: false,
    },
    lectureMeetingCreateDialog: {
      dialog: false,
    },
    citizenParticipationDialog: {
      dialog: false,
    },
    myMeetingJoinDialog: {
      dialog: false,
    },
    myWindow: null,

    allSelected: false,
    checkedMembers: [] /* 체크박스 유저 정보 */,
    conStyle: {
      conferenceTitleW: 240,
      organizerW: 225,
      conferenceTimeW: 182,
      progressW: 199,
      conferencInfoeW: 122,
      modifyW: 132,
    },
    meetingControlDialog: {
      dialog: false,
      meeting: null,
    },
    meetingControlPCMobileOnlyDialog: {
      dialog: false,
      meeting: null,
    },
    addDialog: false,
    editDialog: false,
    removeDialog: false,
    listData: [],
    searchData: [],

    curPageNum: 1,
    curSelectIndex: 0,
    meetingList: [],
    newData: {
      time: '',
      title: '',
      info: '',
    },
    selectedData: {
      time: '',
      title: '',
      info: '',
    },
    meetingInfoDialog: {
      dialog: false,
      meeting: null,
    },
    recInfoDialog: {
      dialog: false,
      meetingInfo: null,
    },

    meetingEditDialog: {
      dialog: false,
      isRoomSelectable: false,
      meeting: null,
    },
    openConfEditDialog: {
      dialog: false,
      meeting: null,
    },
    searchType: 'meetingTitle',
    searchMeeting: null,
  }),
  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      let numPages = Math.ceil(this.searchData.length / this.dataPerPage);
      return numPages === 0 ? 1 : numPages;
    },
    calListData() {
      this.listData = this.meeting;

      return this.listData;
    },
    calData() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      if (this.calListData) {
        return this.calListData.slice(startPage, limitPage);
      } else {
        return [];
      }
    },
    filterLimitMeeting() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.meeting.slice(startPage, limitPage);
    },
  },
  watch: {
    meetingStatus(status) {
      this.search(status);
    },
    startDate: {
      handler(val) {
        // endDate를 1주일 후로 설정.
        this.endDate = moment(val).add(1, 'week').format('YYYY.MM.DD');
      },
    },
  },
  async activated() {
    this.searchMeeting = null;
    
    if (!Util.hasSession(this)) return;
    if (this.$store.state.user.status !== 'u') {
      this.$store.dispatch('setToken', null);
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setLocale', null);
      this.$cookies.remove('token');
      alert('접속이 불가능한 상태입니다. 관리자에게 문의하세요');
      this.$router.push('/403');
    }
    await this.initData();
    await this.search('sc');

    this.$http.get(`/api/v1/systems/checkOpenStatus`, {})
    .then((ret) => {
      this.showRegBtn = ret.data.showRegBtn;
      });
  },
  created() {
    console.log(' ## watch ##');
    setInterval(() => this.search('sc', false), 60000);
    // this.listData = this.meeting;
    this.searchMeeting = null;
    this.curPageNum = 1;
    // this.axios.get('http://localhost:8080/server/listTest.json')
    //   .then((response) => {
    //     this.listData = response.data;
    //     console.log(this.listData);
    //   });
  },
  methods: {
    async initData() {
      this.startDate = moment().add(-2, 'week').format('YYYY.MM.DD');
      this.endDate = moment().add(2, 'week').format('YYYY.MM.DD');
      this.searchText = '';
      this.page = 1;
      this.curPageNum = 1;
    },
    sortTitle() {
      this.cleartSortImage();
      if (this.titleSort === 'asc') {
        this.titleTopImage = '/static/images/button/btn_align_top_on.png';
        this.titleDownImage = '/static/images/button/btn_align_down.png';
        this.titleSort = 'desc';
        this.calData.sort((a, b) => {
          return a.title > b.title ? 1 : -1;
        });
      } else {
        this.titleTopImage = '/static/images/button/btn_align_top.png';
        this.titleDownImage = '/static/images/button/btn_align_down_on.png';
        this.titleSort = 'asc';
        this.calData.sort((a, b) => {
          return a.title > b.title ? -1 : 1;
        });
      }
    },
    sortProcess() {
      this.cleartSortImage();
      if (this.processSort === 'asc') {
        this.processTopImage = '/static/images/button/btn_align_top_on.png';
        this.processDownImage = '/static/images/button/btn_align_down.png';
        this.processSort = 'desc';
        this.calData.sort((a, b) => {
          return a.status > b.status ? 1 : -1;
        });
      } else {
        this.processTopImage = '/static/images/button/btn_align_top.png';
        this.processDownImage = '/static/images/button/btn_align_down_on.png';
        this.processSort = 'asc';
        this.calData.sort((a, b) => {
          return a.status > b.status ? -1 : 1;
        });
      }
    },
    logout() {
      window.getApp.$emit('APP_LOGOUT');
    },
    sortDate() {
      this.cleartSortImage();
      if (this.dateSort === 'asc') {
        this.dateTopImage = '/static/images/button/btn_align_top_on.png';
        this.dateDownImage = '/static/images/button/btn_align_down.png';
        this.dateSort = 'desc';
        this.calData.sort((a, b) => {
          return a.startDtime > b.startDtime
            ? -1
            : b.startDtime > a.startDtime
            ? 1
            : 0;
        });
      } else {
        this.dateTopImage = '/static/images/button/btn_align_top.png';
        this.dateDownImage = '/static/images/button/btn_align_down_on.png';
        this.dateSort = 'asc';
        this.calData.sort((a, b) => {
          return a.startDtime < b.startDtime
            ? -1
            : b.startDtime < a.startDtime
            ? 1
            : 0;
        });
      }
    },
    sortCreator() {
      this.cleartSortImage();
      if (this.creatorSort === 'asc') {
        this.creatorTopImage = '/static/images/button/btn_align_top_on.png';
        this.creatorDownImage = '/static/images/button/btn_align_down.png';
        this.creatorSort = 'desc';
        this.calData.sort((a, b) => {
          return a.creator.name
            ? a.creator.name
            : a.creator.username > b.name
            ? b.creator.name
            : b.creator.username
            ? 1
            : -1;
        });
      } else {
        this.creatorTopImage = '/static/images/button/btn_align_top.png';
        this.creatorDownImage = '/static/images/button/btn_align_down_on.png';
        this.creatorSort = 'asc';
        this.calData.sort((a, b) => {
          return a.creator.name
            ? a.creator.name
            : a.creator.username > b.name
            ? b.creator.name
            : b.creator.username
            ? -1
            : 1;
        });
      }
    },
    sortDept() {
      this.cleartSortImage();
      if (this.deptSort === 'asc') {
        this.deptTopImage = '/static/images/button/btn_align_top_on.png';
        this.deptDownImage = '/static/images/button/btn_align_down.png';
        this.deptSort = 'desc';
        this.calData.sort((a, b) => {
          return a.creator.department > b.creator.department
            ? -1
            : b.creator.department > a.creator.department
            ? 1
            : 0;
        });
      } else {
        this.deptTopImage = '/static/images/button/btn_align_top.png';
        this.deptDownImage = '/static/images/button/btn_align_down_on.png';
        this.deptSort = 'asc';
        this.calData.sort((a, b) => {
          return a.creator.department < b.creator.department
            ? -1
            : b.creator.department < a.creator.department
            ? 1
            : 0;
        });
      }
    },
    cleartSortImage() {
      this.dateTopImage = '/static/images/button/btn_align_top.png';
      this.dateDownImage = '/static/images/button/btn_align_down.png';
      this.processTopImage = '/static/images/button/btn_align_top.png';
      this.processDownImage = '/static/images/button/btn_align_down.png';
      this.titleTopImage = '/static/images/button/btn_align_top.png';
      this.titleDownImage = '/static/images/button/btn_align_down.png';
      this.creatorTopImage = '/static/images/button/btn_align_top.png';
      this.creatorDownImage = '/static/images/button/btn_align_down.png';
      this.deptTopImage = '/static/images/button/btn_align_top.png';
      this.deptDownImage = '/static/images/button/btn_align_down.png';
    },
    notBeforeStartDate(date) {
      return date < new Date(this.startDate);
    },
    notAfterEndDate(date) {
      return date > new Date(this.endDate);
    },
    statusKr(status) {
      let statusKr = '미완료';
      if (status === 'r') {
        statusKr = '예정';
      } else if (status === 's') {
        statusKr = '진행';
      } else {
        statusKr = '완료';
      }
      return statusKr;
    },
    search: debounce(async function (state, isPageInit) {
      if (isPageInit !== false) {
        this.page = 1;
      }
      let startDate = null;
      let endDate = null;
      let neStatus = ['d'];
      if (state === 'init') {
        startDate = moment().add(-2, 'week').format('YYYY.MM.DD');

        endDate = moment().add(2, 'week').format('YYYY.MM.DD');
      } else if ('sc') {
        startDate = this.startDate;
        endDate = this.endDate;
      } else if (state === 'r') {
        this.meetingStatus = 'r';
      } else if (state === 's') {
        this.meetingStatus = 's';
      } else if (state === 'e') {
        this.meetingStatus = 'e';
      }

      if (this.meetingStatus === 'r') {
        neStatus.push('s');
        neStatus.push('e');
      } else if (this.meetingStatus === 's') {
        neStatus.push('e');
        neStatus.push('r');
      } else if (this.meetingStatus === 'e') {
        neStatus.push('r');
        neStatus.push('s');
      } else {
        neStatus = [];
      }

      let params = {
        searchMeeting: this.searchText,
        startDate: moment
          .tz(this.startDate + ' 00:00:00', moment.tz.guess())
          .utc()
          .format(),
        endDate: moment
          .tz(this.endDate + ' 23:59:59', moment.tz.guess())
          .utc()
          .format(),
        neStatus: neStatus,
        sort: 'desc',
        isPublicSort: true, // 공개 회의를 정렬의 맨 앞에 위치 할지 여부
        showPrivated: true, // 비공개 회의 표시 여부
        creator: this.$store.state.user.email,
        email: this.$store.state.user.email,
      };

      await this.$http
        .get('/api/v1/meetings', { params: params })
        .then((response) => {
          this.meeting = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 200),
    submit() {
      const submitData = {
        id: this.newData.id,
        subject: this.newData.subject,
        desc: this.newData.desc,
      };
      /*
      Ajax 통신 후
        */
      this.addData(submitData);
      this.clearForm();
    },
    editData() {
      const editData = {
        time: this.selectedData.time,
        title: this.selectedData.title,
        info: this.selectedData.info,
      };
      /*
      Ajax 통신 후
        */
      this.calListData.splice(this.curSelectIndex, 1, editData);
    },
    addData(submitData) {
      this.calListData.push(submitData);
      this.curPageNum = this.numOfPages;
    },
    removeData() {
      this.calListData.splice(this.curSelectIndex, 1);
      if (this.calData.length === 0) {
        this.prevPage();
      }
    },
    selectAll() {
      let calData = this.filterLimitMeeting;
      this.checkedMember = [];

      if (!this.allSelected) {
        for (let member = 0; member < calData.length; member++) {
          this.checkedMembers.push(calData[member].meetingKey);
        }
      } else {
        this.checkedMembers = [];
      }
    },
    onAdd() {
      this.addDialog = true;
    },
    onRemove(index) {
      this.curSelectIndex = this.calIndex(index);

      this.removeDialog = true;
    },
    onInfo(meeting) {
      this.bgActive = true;
      this.meetingInfoDialog.dialog = true;
      this.meetingInfoDialog.meeting = meeting;
    },
    async controlItem(item) {
      console.log(`item`, item);
      // Get Meeting
      if (item.conferenceRoomActive === true) {
        console.log(`item.conferenceRoomActive`, item.conferenceRoomActive);
        this.meetingControlDialog.meeting = item;
        this.meetingControlDialog.dialog = true;
      } else {
        console.log(`item.conferenceRoomActive2`, item.conferenceRoomActive);
        this.meetingControlPCMobileOnlyDialog.meeting = item;
        this.meetingControlPCMobileOnlyDialog.dialog = true;
      }
    },
    calIndex(index) {
      switch (this.curPageNum) {
        case 1:
          return index;
        default:
          return index + (this.curPageNum - 1) * this.dataPerPage;
      }
    },
    clearForm() {
      // for (let key in this.newData) {
      //   this.newData[key] = '';
      // }
    },
    prevPage() {
      this.curPageNum--;
    },
    closeMeetingInfoDialog(type) {
      this.bgActive = false;
      this.meetingInfoDialog.dialog = false;
      // 설문조사 삭제 후 > 미팅 상세 정보 닫을 경우 갱신 안되는 현상으로
      if (type === 'delete') {
        this.search('sc');
      }
    },
    closeRecInfoDialog() {
      this.recInfoDialog.meetingId = null;
      this.recInfoDialog.dialog = false;
    },
    closeMeetingControlDialog(type) {
      if (type === 'pcmobile') {
        this.meetingControlPCMobileOnlyDialog.dialog = false;
      } else {
        this.meetingControlDialog.dialog = false;
      }
      this.search('start');
    },
    startVideo(obj) {
      this.videoDialog.dialog = true;
      this.videoDialog.meetingInfo = obj;
    },
    closeVideoDialog() {
      this.videoDialog.dialog = false;
    },
    openConfirmDialog(item) {
      this.startMeetingItem = item;
      this.confirmAgree();
    },
    openRecInfodailog(item) {
      this.recInfoDialog.meetingInfo = item;
      this.recInfoDialog.dialog = true;
    },
    confirmAgree() {
      // 동의 완료
      if (this.startMeetingItem.isPrivate) {
        this.checkPasswordDialog.dialog = true;
        this.checkPasswordDialog.meetingInfo = this.startMeetingItem;
      } else {
        this.startMeeting(this.startMeetingItem);
      }
    },
    joinPwMeeting() {
      this.checkPasswordDialog.dialog = false;
      this.startMeeting(this.startMeetingItem);
    },
    closeConfirm() {
      this.confirmDialog.dialog = false;
      this.startMeetingItem = {};
    },
    closePassword () {
      this.checkPasswordDialog.dialog = false;
    },
    async startMeeting(item) {
      this.loading = true;
      if (item.status === 'r') {
        this.bgActive = true;
        this.myMeetingJoinDialog.dialog = true;
        this.meetingInfo = item;

        // let meetingKey = encodeURI(encodeURIComponent(item.meetingKey));
        // let userKey = encodeURI(
        //   encodeURIComponent(this.$store.state.user.username)
        // );
        // this.myWindow = window.open(
        //   "/JoinMeetingDialog?meetingKey=" + meetingKey + "&userKey=" + userKey,
        //   "_blank",
        //   "width=360, height=225"
        // );
        return false;
      }
      item['me'] = {
        email: this.$store.state.user.email,
        displayName: this.$store.state.user.name
          ? this.$store.state.user.name
          : this.$store.state.user.email, // this.$store.state.user.displayFullName ? this.$store.state.user.displayFullName : this.$store.state.user.username
      };

      let params = {
        _id: item._id,
        me: item.me,
        email: this.$store.state.user.email,
        coSpaceUri: item.meetingKey,
        meetingKey: item.meetingKey,
        userKey: this.$store.state.user.name,
      };

      let layoutCode = null;
      let fixSeatList = null;

      if (item.exMeeting === true) {
        if (item.conferenceRoomActive === false) {
          console.log('외부망 일반회의');

          let joinUserType = 22;
          if (item.creator.email === this.$store.state.user.email) {
            joinUserType = 1;
          }

          await this.$http
            .get(`/api/auth/joinUrlForDmzSaehaInfo`, { params: params })
            .then((response) => {
              let info = response.data;
              console.log(info);
              const ds = this.$BodaApp.defaultSettings(info.ds);

              this.$BodaApp.openJoin(
                {
                  roomCode: item.meetingKey,
                  template: info.meetingInfo.meetingLog ? 168 : 163,
                  title: item.title,
                  userType:
                    item.creator.email === this.$store.state.user.email
                      ? 1
                      : 13,

                  userId: info.userData.userId,
                  userName: info.userData.userName,
                  openOption: info.meetingInfo.roomOption,
                },
                () => {
                  console.log('success');
                },
                (errorCode, reason) => {
                  console.log(errorCode, reason);
                  if (
                    errorCode === 'BODA-NOT_INSTALLED' ||
                    errorCode === 'BODA-NOT_CONNECTED_AGENT'
                  ) {
                    this.$BodaApp.downloadClient(
                      {},
                      function () {
                        // 성공 시 처리
                      },
                      function (errorCode, reason) {
                        // 오류 시 처리
                      }
                    );
                  } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                    if (reason === 'CLIENT_RUNNING') {
                      alert(
                        '영상회의 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                      );
                    }
                  }
                  this.loading = false;
                }
              );
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        } else if (item.conferenceRoomActive === true) {
          console.log('외부망 CMS 미팅');
          // CMS 미팅인 경우
          await this.$http
            .get(`/api/auth/dmzSaehaInfo`, { params: params })
            .then((response) => {
              let info = response.data;
              if (info.useClientType === 'SAEHA') {
                const ds = this.$BodaApp.defaultSettings(info.ds);
                this.$BodaApp.openJoin(
                  {
                    roomCode: info.oj.roomCode,
                    template: Number(info.oj.template),
                    title: item.title,
                    userType:
                      item.creator.email === this.$store.state.user.email
                        ? 1
                        : 13,

                    userId: info.userData.userId,
                    userName:
                      info.userData.userName + `/${info.userData.userId}`,
                    openOption: info.oj.openOption,
                    joinOption: info.oj.joinOption,

                    // roomCode: item.meetingKey,
                    // template: Number(info.oj.template),
                    // title: item.title,
                    // joinUserType: joinUserType,
                    // userId: this.$store.state.user.email,
                    // userName: item.me.displayName, // this.$store.state.user.displaySaehaName ? this.$store.state.user.displaySaehaName : this.$store.state.user.username, // this.$store.state.user.displayFullName ? this.$store.state.user.displayFullName : this.$store.state.user.username,
                    // roomOption: item.roomOption
                  },
                  () => {
                    console.log('success');
                  },
                  (errorCode, reason) => {
                    console.log(errorCode, reason);
                    if (
                      errorCode === 'BODA-NOT_INSTALLED' ||
                      errorCode === 'BODA-NOT_CONNECTED_AGENT'
                    ) {
                      this.$BodaApp.downloadClient(
                        {},
                        function () {
                          // 성공 시 처리
                        },
                        function (errorCode, reason) {
                          // 오류 시 처리
                        }
                      );
                    } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                      if (reason === 'CLIENT_RUNNING') {
                        alert(
                          '영상회의 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                        );
                      }
                    }
                    this.loading = false;
                  }
                );
              }
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      } else {
        if (item.conferenceRoomActive === false) {
          console.log('## 내부망 일반회의 ##');
          this.$http
            .get(`/api/auth/joinUrlForSaehaInfo`, {
              params: params,
            })
            .then((response) => {
              let info = response.data;
              console.log(`roomOption : `, info);
              const ds = this.$BodaApp.defaultSettings(info.ds);
              console.log(`ds : `, ds);
              // let templateCode = Number(info.oj.template);

              this.$BodaApp.openJoin(
                {
                  roomCode: info.meetingInfo.meetingKey,
                  template: Number(info.oj.template),
                  title: info.meetingInfo.title,
                  userType: info.oj.joinUserType,
                  userId: info.userData.userId,
                  userName: info.userData.userName + `/${info.userData.callNm}`,
                  openOption: info.meetingInfo.roomOption
                    ? info.meetingInfo.roomOption
                    : '',
                },
                () => {
                  console.log('success');
                },
                (errorCode, reason) => {
                  console.log(errorCode, reason);
                  if (
                    errorCode === 'BODA-NOT_INSTALLED' ||
                    errorCode === 'BODA-NOT_CONNECTED_AGENT'
                  ) {
                    this.$BodaApp.downloadClient(
                      {},
                      function () {
                        // 성공 시 처리
                      },
                      function (errorCode, reason) {
                        // 오류 시 처리
                      }
                    );
                  } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                    if (reason === 'CLIENT_RUNNING') {
                      alert(
                        '영상회의 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                      );
                    }
                  }
                  this.loading = false;
                }
              );
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        } else if (item.conferenceRoomActive === true) {
          console.log(' ### 내부망 CMS미팅 ###');
          console.log(' ###익현과장###');
          // CMS 미팅인 경우
          this.$http
            .get(`/api/auth/saehaInfo`, { params: params })
            .then((response) => {
              let info = response.data;
              console.log(info);
              const ds = this.$BodaApp.defaultSettings(info.ds);
              const joinInfo = {
                roomCode: info.oj.roomCode,
                template: Number(info.oj.template),
                title: info.oj.title,
                userType:
                  item.creator.email === this.$store.state.user.email ? 1 : 13,
                userId: info.userData.userId,
                userName: info.userData.userName,
                openOption: info.oj.openOption,
                joinOption: info.oj.joinOption,
              };
              console.log('join info: ', joinInfo);

              this.$BodaApp.openJoin(
                joinInfo,
                () => {
                  console.log('success');
                  // this.meeting = Object.assign({}, this.defaultMeeting);
                  // this.initMeeting();
                },
                (errorCode, reason) => {
                  console.log(errorCode, reason);
                  if (
                    errorCode === 'BODA-NOT_INSTALLED' ||
                    errorCode === 'BODA-NOT_CONNECTED_AGENT'
                  ) {
                    this.$BodaApp.downloadClient(
                      {},
                      function () {
                        // 성공 시 처리
                      },
                      function (errorCode, reason) {
                        // 오류 시 처리
                      }
                    );
                  }
                  this.loading = false;
                }
              );

              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      }
    },
    async onEdit(meeting) {
      this.editMeetingDialog.dialog = true;
      this.editMeetingDialog.meeting = meeting;
    },
    closeMeetingEditDialog() {
      this.meetingEditDialog.dialog = false;
      this.search();
    },
    closeOpenConfEditDialog() {
      this.openConfEditDialog.dialog = false;
      this.search();
    },
    async joinMeeting(meeting) {
      // Get Meeting Url
      let params = {
        email: this.$store.state.user.email,
        meetingId: meeting._id,
      };
      await this.$http
        .get('/api/v1/meetings/joinUrl', { params: params })
        .then((response) => {
          let joinUrl = response.data.joinUrl;
          window.open(joinUrl);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showEditBtn(listItem) {
      if (
        (['r'].includes(listItem.status) ||
          (listItem.conferenceRoomActive === true &&
            ['s'].includes(listItem.status))) &&
        listItem.creator.email === this.$store.state.user.email
      ) {
        return true;
      } else {
        return false;
      }
    },
    async searchMeetingList() {
      let searchMeeting = this.searchMeeting;
      let searchType = this.searchType;
      let params = {};
      if (searchType === 'meetingTitle') {
        params = {
          searchMeeting: searchMeeting,
          status: ['s'],
        };
      } else if (searchType === 'meetingCreator') {
        params = {
          analyticsCreator: searchMeeting,
          status: ['s'],
        };
      } else if (searchType === 'meetingDepartment') {
        params = {
          searchDepartment: searchMeeting,
          status: ['s'],
        };
      }

      await this.$http
        .get('/api/v1/meetings', {
          params,
        })
        .then((response) => {
          console.log(response);
          this.meeting = response.data.splice(0, 100);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createdMeeting(ret) {
      console.log('createMeeting ');
      console.log(ret);
      this.search('sc');
    },
    myMeetingJoin(ret) {
      console.log(' ## myMeetingJoin ##');
      if (ret === 'close') {
        this.myMeetingJoinDialog.dialog = false;
        this.bgActive = false;
      } else {
        this.startMeeting(ret);
      }
    },
    closeMeetingCreateDialog() {
      this.videoMeetingCreateDialog.dialog = false;
      this.lectureMeetingCreateDialog.dialog = false;
      this.bgActive = false;
      this.search();
    },
    allowedStartDates(d) {
      return moment(d).format('YYYY.MM.DD') >= moment().format('YYYY.MM.DD');
    },
    allowedEndDates(d) {
      return (
        moment(d).format('YYYY.MM.DD') >=
        moment(this.startDate).format('YYYY.MM.DD')
      );
    },
    showDatePicker(state) {
      if (state === 'hero') {
        if (this.isActive === '') {
          this.isActive = 'none';
        }
      } else {
        console.log('????');
        if (this.isActive === 'none') {
          this.isActive = '';
          this.isEndActive = 'none';
        } else {
          this.isActive = 'none';
        }
      }
    },
    startDateChange() {
      this.isActive = 'none';
      // this.startDate(this.startDate);
    },
    showEndDatePicker() {
      if (this.isEndActive === 'none') {
        this.isEndActive = '';
        this.isActive = 'none';
      } else {
        this.isEndActive = 'none';
      }
    },
    endDateChange() {
      this.isEndActive = 'none';
      // this.startDate(this.startDate);
    },
    openVideoMeetingCreateDialog() {
      this.videoMeetingCreateDialog.dialog = true;
    },
    async goMeeting(data) {
      this.bgActive = true;
      // 등록된 회의실이 존재 하는지 체크
      switch (data) {
        case 'video':
          this.openVideoMeetingCreateDialog();
          break;
        case 'conference':
          this.$router.push({ name: 'Meeting' });
          break;
        case 'external':
          console.log('외부망으로 이동링크');
          break;
      }
    },
    openWindow() {
      let creator = encodeURI(encodeURIComponent('A100022112'));
      let messengerId = encodeURI(encodeURIComponent('123123132'));
      let member = encodeURI(encodeURIComponent('00000033|00000032|00000031'));
      let meetingType = encodeURI(encodeURIComponent('portalOrga'));
      this.myWindow = window.open(
        '/messengerDialog?userKey=' +
          creator +
          '&messengerId=' +
          messengerId +
          '&meetingType=' +
          meetingType +
          '&member=' +
          member,
        '_blank',
        'width=720, height=660'
      );
      return false;
    },
    async downloadRecord(item) {
      let body = {
        userId: this.$store.state.user.email.split('@')[0],
        title: item.title,
        meetingKey: item.meetingKey,
      };
      await this.$http
        .post('/api/v1/meetings/ksd/sendRecord', body)
        .then((response) => {
          if (response) {
            alert('녹화파일이 문서중앙화로 다운로드 되었습니다.');
          }
        })
        .catch((error) => {
          console.log(error);
        });
      // 문서 중앙화
    },
    editedMeeting() {
      this.editMeetingDialog.dialog = false;
      this.search('r');
    },
    // 회의 시작 날짜와 종료 날짜가 다른경우 날짜 표시 방법 수정
    getMeetingDateString (item) {
      const startDate = moment(item.startDtime).format('YYYY.MM.DD');
      const endDate = moment(item.endDtime).format('YYYY.MM.DD');
      if (startDate === endDate) {
        return startDate;
      } else {
        const displayEndDate = moment(item.endDtime).format('MM.DD');
        return `${startDate} ~ ${displayEndDate}`;
      }
    }
  },
};
</script>
<style scoped>
.v-date-picker-table {
  height: auto;
}

.select-subTitle {
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: -0.03em;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.all-public-meeting {
  position: relative;
  top: 3px;
  left: -3px;
  cursor: pointer;
}

.v-icon {
  position: relative;
  top: 2px;
  cursor: pointer;
}

.top img {
  width: 13px;
  height: 13px;
  cursor: pointer;
}

.sort-wrap {
  line-height: 47px;
}
.upDown-img-wrap {
  display: inline-block;
  position: relative;
  width: 26px;
  height: 26px;
  top: 8px;
  left: 10px;
}

.up-img {
  position: absolute;
  top: 0;
  left: 0;
}

.down-img {
  position: absolute;
  top: 13px;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Kmeeting.vue